import script from "./RoleRequiredByStaff.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoleRequiredByStaff.vue?vue&type=script&setup=true&lang=ts"

import "./RoleRequiredByStaff.vue?vue&type=style&index=0&id=e9244d58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9244d58"]])

export default __exports__